export function HeroArrow() {
  return (
    <a className="hero-arrow" href="#intro" aria-label="Continue to the next section">
      <svg className="hero-arrow-icon" viewBox="0 0 40 48" aria-hidden>
        <path d="M8 8 L20 22 L32 8" />
        <path d="M8 22 L20 36 L32 22" />
      </svg>
    </a>
  );
}
